import React from 'react'
import { classNames } from 'az-platform-ui';

const Page = ({ children, className, isSidebar }) => {
  let addClass = className ? className : '';
  let style = { width: `calc(100% - ${isSidebar ? 64 : 0}px)` }
  return (
    <section className={`h-screen flex flex-column ${addClass}`} style={style}>
      {children}
    </section>
  )
}

const Header = ({ children }) => {
  return (
    <header className="flex-grow-none shadow-2">
      {children}
    </header>
  )
}

const Content = ({ children , isHeader}) => {
  return (
    <div className= {classNames('overflow-y-auto flex-grow-1', {'h-full': isHeader})}>
      {children} 
    </div>
  )
}

Page.Header = Header
Page.Content = Content

export default Page